var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteFolder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666967 4H12.551C12.6432 3.99996 12.7344 4.01906 12.8189 4.05609C12.9034 4.09312 12.9793 4.14728 13.0417 4.21514C13.1042 4.283 13.1519 4.36308 13.1819 4.45033C13.2118 4.53757 13.2233 4.63008 13.2156 4.722L12.6596 11.3887C12.6458 11.5553 12.5698 11.7106 12.4468 11.8238C12.3238 11.937 12.1628 11.9999 11.9956 12H1.2223C1.05513 11.9999 0.894098 11.937 0.771114 11.8238C0.648131 11.7106 0.572176 11.5553 0.5583 11.3887L0.00230037 4.722C-0.0053553 4.63008 0.00614631 4.53757 0.0360778 4.45033C0.0660092 4.36308 0.113719 4.283 0.17619 4.21514C0.238662 4.14728 0.314535 4.09312 0.399012 4.05609C0.483488 4.01906 0.57473 3.99996 0.666967 4ZM1.83563 10.6667H11.3823L11.8263 5.33333H1.39163L1.83563 10.6667ZM7.55163 1.33333H11.9423C12.1191 1.33333 12.2887 1.40357 12.4137 1.5286C12.5387 1.65362 12.609 1.82319 12.609 2V2.66667H0.608967V0.666667C0.608967 0.489856 0.679205 0.320286 0.804229 0.195262C0.929253 0.0702379 1.09882 0 1.27563 0H6.2183L7.55163 1.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFolder);
export default __webpack_public_path__ + "static/media/white-folder.374a5b5eb1b94120bf8811fdc063eb57.svg";
export { ForwardRef as ReactComponent };